<div *ngIf="screen == 'loading'">
    <div class="account-pages pt-sm-5 position-relative">
        <div class="container login-container">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-7 col-xl-6">
                    <div class="row text-center card-title mt-2">
                        <p>{{'LOCALIZE.LOADING' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- AI CONSENT -->
<div *ngIf="screen == 'ai-consent'">
    <div class="account-pages pt-sm-5 position-relative">
        <div class="back-ground-image1">
            <img src="assets/images/login_page_images/Ellipse 3.svg" alt="Ellipse">
        </div>
        <div class="back-ground-image2">
            <img src="assets/images/login_page_images/Ellipse 4.svg" alt="Ellipse">
        </div>
        <div class="back-ground-image3">
            <img src="assets/images/login_page_images/Mask Group.svg" alt="Ellipse">
        </div>

        <div class="container login-container">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-7 col-xl-6">
                    <div class="card overflow-hidden">
                        <div class="row justify-content-center">
                            <div class="sparrks-logo">
                                <img src="assets/images/sparrks.svg" alt="Sparrks logo" class="">
                            </div>
                        </div>
                        <div class="row text-center card-title mt-2">
                            <p>{{'LOCALIZE.OPTIONAL_AI_FEATURES' | translate}}</p>
                        </div>

                        <div class="row text-center mt-2">
                            <p>{{'LOCALIZE.OPTIONAL_AI_FEATURES_LEAD' | translate}}</p>
                        </div>

                        <div class="card-body pt-0">
                            <div class="p-2">
                                <div class="mb-3 mt-4">
                                    <div class="d-flex align-items-center">
                                        <div class="fw-normal">
                                            {{'LOCALIZE.OPTIONAL_AI_FEATURES_CTA_P1' | translate}}
                                            <a routerLink="/coachee-ai-agreement" [queryParams]="{lang: language}"
                                                target="_blank">{{'LOCALIZE.CONSENT_DECLARATION' | translate}}</a>
                                            {{'LOCALIZE.OPTIONAL_AI_FEATURES_CTA_P2' | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3 text-center"
                                    style="display: flex; flex-direction: row; justify-content: space-between;">

                                    <button class="btn btn-secondary" (click)="handleRejectAi()" [disabled]="pending">
                                        <div *ngIf="pending">
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true"></span>
                                                {{'LOGIN.LOADING' | translate}}
                                            </div>
                                            <span *ngIf="!pending">
                                                {{'LOCALIZE.REJECT' | translate}}
                                            </span>
                                    </button>
                                    <span>
                                        <button class="btn primary-btn mt-2"
                                            (click)="handleAcceptAi()"
                                            role="button" tabindex="0"
                                            [attr.aria-label]="'LOCALIZE.CONTINUE' | translate"
                                            >
                                            <div *ngIf="pending">
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true"></span>
                                                {{'LOGIN.LOADING' | translate}}
                                            </div>
                                            <span *ngIf="!pending">
                                                {{'LOCALIZE.ACCEPT' | translate}}
                                            </span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- DPA CONSENT -->
<div *ngIf="screen == 'dpa-consent'">
    <div class="account-pages pt-sm-5 position-relative">
        <div class="back-ground-image1">
            <img src="assets/images/login_page_images/Ellipse 3.svg" alt="Ellipse">
        </div>
        <div class="back-ground-image2">
            <img src="assets/images/login_page_images/Ellipse 4.svg" alt="Ellipse">
        </div>
        <div class="back-ground-image3">
            <img src="assets/images/login_page_images/Mask Group.svg" alt="Ellipse">
        </div>

        <div class="container login-container">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-7 col-xl-6">
                    <div class="card overflow-hidden">
                        <div class="row justify-content-center">
                            <div class="sparrks-logo">
                                <img src="assets/images/sparrks.svg" alt="Sparrks logo" class="">
                            </div>
                        </div>
                        <div class="row text-center card-title mt-2">
                            <p>{{'LOCALIZE.DATA_PROTECTION' | translate}}</p>
                        </div>

                        <div class="row text-center mt-2">
                            <p>{{'LOCALIZE.DATA_PROTECTION_DESCRIPTION' | translate}}</p>
                        </div>

                        <div class="card-body pt-0">
                            <div class="p-2">
                                <div class="mb-3 mt-4">
                                    <div class="d-flex align-items-center">
                                        <input type="checkbox" class="mr-3" [disabled]="pending" [(ngModel)]="dpaChecked">
                                        <label for="agreeToDataProtection" style="padding-left: 10px;"
                                            class="fw-normal">
                                            {{'LOGIN.AGREE_TOS_TEXT_P1' | translate}}
                                            <a routerLink="/coachee-dpa" [queryParams]="{lang: language}"
                                                target="_blank">{{'LOGIN.AGREE_TOS_TEXT_P2' | translate}}</a>
                                            {{'LOGIN.AGREE_TOS_TEXT_P3' | translate}}
                                        </label>
                                    </div>
                                </div>
                                <div class="mt-3 text-center"
                                    style="display: flex; flex-direction: row; justify-content: space-between;">

                                    <button class="btn btn-secondary" (click)="handleLogout()" [disabled]="pending">
                                        {{'LOCALIZE.LOGOUT' | translate}}
                                    </button>
                                    <span>
                                        <button class="btn primary-btn mt-2"
                                            (click)="handleRecordConsent()"
                                            [disabled]="!submitEnabled" role="button" tabindex="0"
                                            [attr.aria-label]="'LOCALIZE.CONTINUE' | translate"
                                            [attr.aria-disabled]="!submitEnabled">
                                            <div *ngIf="pending">
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true"></span>
                                                {{'LOGIN.LOADING' | translate}}
                                            </div>
                                            <span *ngIf="!pending">
                                                {{'LOCALIZE.AGREE_AND_CONTINUE' | translate}}
                                            </span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-content *ngIf="screen == 'content'"></ng-content>